import {Emisor} from './emisor';

export class Receiver {
    idDocType: string;
    idDocNumber: string;
    businessName: string;
    address: string;
    department: string;
    province: string;
    district: string;
    countryCode: string;
    phone: string;
    email: string;
    customer: Emisor;

    constructor() {
        this.idDocType = '6';
        this.idDocNumber = '';
        this.businessName = '';
        this.address = '';
        this.department = '';
        this.province = '';
        this.district = '';
        this.countryCode = '';
        this.phone = '';
        this.email = '';
        this.customer = new Emisor();
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/Receiver.ts